import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Video from 'yet-another-react-lightbox/plugins/video';

import 'yet-another-react-lightbox/styles.css';

const VideoPopupLightbox = ({ videoSlide, children, className }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className={`${className} cursor-pointer`}
        onClick={(e) => {
          setOpen(true);
          e.stopPropagation();
        }}
      >
        {children}
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={[videoSlide]}
        plugins={[Video]}
        controller={{ closeOnBackdropClick: true }}
        animation={{ fade: true }}
        styles={{
          container: {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
          },
        }}
        render={{
          buttonPrev: () => null,
          buttonNext: () => null,
        }}
      />
    </>
  );
};

export default VideoPopupLightbox;
